export class NotificationWorkItemNavigationEvent {
  workItemIds: number[];
}
